<template>
    <div>
        <private-fl44-contract-supplementary-agreement-sign-form-customer v-if="purchase.actions.customer.supplementary_agreement === 'sign'" :purchase="purchase" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" />

        <template v-else-if="purchase.actions.customer.supplementary_agreement === 'reply'">
            <private-fl44-contract-supplementary-agreement-regular-customer-reply-block v-if="supplementaryAgreement.type.id === 'regular'" :purchase="purchase" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" :contractPriceTotal="contractPriceTotal" />
            <private-fl44-contract-supplementary-agreement-termination-customer-reply-block v-if="supplementaryAgreement.type.id === 'termination'" :purchase="purchase" @refresh="$emit('refresh')" :supplementary-agreement="supplementaryAgreement" :contractPriceTotal="contractPriceTotal" />
        </template>
        <fl44-customer-sign-decline-supplementary-agreement-button v-else-if="purchase.actions.customer.supplementary_agreement === 'wait'" :purchase="purchase" :supplementary-agreement="supplementaryAgreement" class="mb-2" @refresh="$emit('refresh')" />
    </div>
</template>

<script>
import PrivateFl44ContractSupplementaryAgreementSignFormCustomer from '@/components/products/fl44/partials/private-fl44-contract-supplementary-agreement-sign-form-customer.vue';
import PrivateFl44ContractSupplementaryAgreementRegularCustomerReplyBlock from '@/components/products/fl44/partials/private-fl44-contract-supplementary-agreement-regular-customer-reply-block.vue';
import PrivateFl44ContractSupplementaryAgreementTerminationCustomerReplyBlock from '@/components/products/fl44/partials/private-fl44-contract-supplementary-agreement-termination-customer-reply-block.vue';
import Fl44CustomerSignDeclineSupplementaryAgreementButton from '@/components/products/fl44/partials/fl44-customer-sign-decline-supplementary-agreement-button.vue';

export default {
    name: 'private-fl44-contract-supplementary-agreement-customer-block',
    components: {
        Fl44CustomerSignDeclineSupplementaryAgreementButton,
        PrivateFl44ContractSupplementaryAgreementTerminationCustomerReplyBlock,
        PrivateFl44ContractSupplementaryAgreementRegularCustomerReplyBlock,
        PrivateFl44ContractSupplementaryAgreementSignFormCustomer
    },
    props: {
        purchase: {
            type: Object,
            required: true
        },
        supplementaryAgreement: {
            type: Object,
            required: true
        },
        contractPriceTotal: {
            type: Number
        }
    }
};
</script>
